import { render } from "./MoreIcons.vue?vue&type=template&id=c73393e2"
import script from "./MoreIcons.vue?vue&type=script&lang=js"
export * from "./MoreIcons.vue?vue&type=script&lang=js"
script.render = render

export default script